module.exports = __webpack_public_path__ + "static/media/queensLegacyLogo.372d8682.png";